import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon, CheckIcon } from '@heroicons/react/24/outline';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' }
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  
  // Get current language display info
  const currentLanguage = languages.find(
    lang => i18n.language === lang.code || i18n.language.startsWith(lang.code)
  ) || languages[0];
  
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="inline-flex items-center justify-center rounded-md px-2 py-1.5 text-sm text-gray-600 hover:bg-gray-50 transition-colors focus:outline-none">
          <span className="font-medium">{currentLanguage.code.toUpperCase()}</span>
          <ChevronDownIcon className="ml-1 h-3.5 w-3.5 opacity-70" aria-hidden="true" />
        </Menu.Button>
      </div>
      
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-1.5 w-36 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
          <div className="px-1 py-1">
            {languages.map((language) => (
              <Menu.Item key={language.code}>
                {({ active }) => (
                  <button
                    onClick={() => changeLanguage(language.code)}
                    className={`${
                      active ? 'bg-gray-50' : ''
                    } group flex w-full items-center rounded-md px-2 py-2 text-sm ${
                      currentLanguage.code === language.code ? 'font-medium' : 'font-normal'
                    }`}
                  >
                    <div className="flex-grow text-left">{language.label}</div>
                    {currentLanguage.code === language.code && (
                      <CheckIcon className="ml-2 h-4 w-4 text-black" aria-hidden="true" />
                    )}
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default LanguageSwitcher; 